import React, { useState, useRef } from 'react';

import { Tabs, Tab, Label, Panel, PanelContainer } from './Strategy.styled';

import { LargeContentTabNavigationProps } from '../Content/Large';

const Strategy: React.FC<LargeContentTabNavigationProps> = props => {
    const { tabs } = props;
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [hoverTabIndex, setHoverTabIndex] = useState<null | number>(null);
    const tabsRef = useRef<HTMLDivElement>(null);

    const handleTabKeydown = (event: React.KeyboardEvent) => {
        if (tabsRef.current && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
            const tabsEl = tabsRef.current;
            let newIndex: number;

            if (event.key === 'ArrowLeft') {
                newIndex = activeTabIndex - 1 < 0 ? tabs.length - 1 : activeTabIndex - 1;
            } else {
                newIndex = activeTabIndex + 1 > tabs.length - 1 ? 0 : activeTabIndex + 1;
            }

            setActiveTabIndex(newIndex);
            (tabsEl.children[newIndex] as HTMLButtonElement).focus();
        }
    };
    return (
        <>
            <Tabs role="tablist" aria-label="Strategy content information tabs" ref={tabsRef}>
                {props.tabs.map((tab, index) => (
                    <Tab
                        id={`tab-${tab.id}`}
                        key={`tab-${tab.id}`}
                        role="tab"
                        aria-label={tab.ariaLabel}
                        aria-selected={index === activeTabIndex}
                        aria-controls={`panel-${tab.id}`}
                        tabIndex={index === activeTabIndex ? 0 : -1}
                        onClick={() => setActiveTabIndex(index)}
                        onKeyDown={handleTabKeydown}
                        onMouseOver={() => setHoverTabIndex(index)}
                        onMouseOut={() => setHoverTabIndex(null)}
                        data-hover={hoverTabIndex === index}
                        $isActive={index === activeTabIndex}
                    >
                        {tab.label && (
                            <Label $isActive={index === activeTabIndex}>{tab.label}</Label>
                        )}
                    </Tab>
                ))}
            </Tabs>
            <PanelContainer>
                {tabs.map((tab, index) => (
                    <Panel
                        id={`panel-${tab.id}`}
                        key={`panel-${tab.id}`}
                        role="tabpanel"
                        tabIndex={0}
                        aria-labelledby={`tab-${tab.id}`}
                        hidden={activeTabIndex !== index}
                    >
                        {tab.content}
                    </Panel>
                ))}
            </PanelContainer>
        </>
    );
};

export default Strategy;
